import _memoize from 'lodash/memoize';
import { makeThemeColor, TERTIARY } from '@tornado-rdk/theme';
import { FONT, getFont } from '@tornado-rdk/typography';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { SCREEN_HEIGHT, SCREEN_WIDTH, middle, identity } from '../../tornado/utils/sizes';
import { TRANSPARENT } from '../../tornado/utils/colors';

export const defaultContext = makeDefaultStylingContext();

export const CONTENT_SIDE_MARGIN = {
  [HD]: 320,
  [FULL_HD]: 480,
};

export const TITLE_TOP_MARGIN = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const DESCRIPTION_TOP_MARGIN = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const BUTTONS_MARGIN = {
  [HD]: 8,
  [FULL_HD]: 12,
};

export const BUTTONS_TOP_MARGIN = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const ICON_SIZE = {
  WIDTH: {
    [HD]: 60,
    [FULL_HD]: 72,
  },
  HEIGHT: {
    [HD]: 60,
    [FULL_HD]: 72,
  },
};

export const CSA18_ICON = { name: 'Csa18', type: 'icon' };

export const getIconViewBox = _memoize(screenSize => ({
  w: ICON_SIZE.WIDTH[screenSize],
  h: ICON_SIZE.HEIGHT[screenSize],
}));

export const colors = {
  background: makeThemeColor(TERTIARY),
  darkering: makeThemeColor(TERTIARY, 0.8),
};

export const getInitialStyle = _memoize((context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const titleFont = getFont(FONT.KINSHASA_3, screenSize);
  const descriptionFont = getFont(FONT.OTTAWA_2, screenSize);
  const wordWrapWidth = SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;

  return {
    rect: true,
    color: colors.background[colorMode],
    h: SCREEN_HEIGHT[screenSize],
    w: SCREEN_WIDTH[screenSize],
    BackgroundPoster: {
      w: identity,
      h: identity,
    },
    Darkering: {
      w: identity,
      h: identity,
      rect: true,
      color: colors.darkering[colorMode],
    },
    FlexContainer: {
      x: middle,
      y: middle,
      mountY: 0.5,
      flex: { direction: 'column', justifyContent: 'center' },
      IconWrapper: {
        rect: true,
        color: TRANSPARENT,
        mountX: 0.5,
        w: getIconViewBox(screenSize).w,
        h: getIconViewBox(screenSize).h,
        Icon: {
          iconData: {
            picto: CSA18_ICON,
            viewBox: getIconViewBox(screenSize),
          },
        },
      },
      Title: {
        flexItem: { marginTop: TITLE_TOP_MARGIN[screenSize] },
        mountX: 0.5,
        text: {
          textAlign: 'center',
          wordWrapWidth,
          maxLines: 2,
          maxLinesSuffix: '...',
          ...titleFont,
        },
      },
      Description: {
        flexItem: { marginTop: DESCRIPTION_TOP_MARGIN[screenSize] },
        mountX: 0.5,
        text: {
          textAlign: 'center',
          wordWrapWidth,
          ...descriptionFont,
        },
      },
      ButtonsSection: {
        flexItem: { marginTop: BUTTONS_TOP_MARGIN[screenSize] },
        flex: { direction: 'row', justifyContent: 'center' },
        mountX: 0.5,
        CancelButton: {
          flexItem: {
            marginRight: BUTTONS_MARGIN[screenSize],
          },
          colorMode,
        },
        OkButton: {
          flexItem: {
            marginLeft: BUTTONS_MARGIN[screenSize],
          },
          colorMode,
        },
      },
    },
  };
});
